







































import Vue from 'vue';
import Modal from '../components/common/Modal/Modal.vue';
import Input from '../components/common/Input/Input.vue';
import NotificationText from '../components/common/NotificationText/NotificationText.vue';
import TextArea from '../components/common/TextArea/TextArea.vue';
import Button from '../components/common/Button/Button.vue';

import { axiosApiInstance } from '../utils/axiosInstances';
export default Vue.extend({
  components: {
    Modal,
    Input,
    Button,
    NotificationText,
    TextArea,
  },
  data(): {
    workspaceName: string;
    workspaceDescription: string;
    nameError: boolean;
    descriptionError: boolean;
  } {
    return {
      workspaceName: '',
      workspaceDescription: '',
      nameError: false,
      descriptionError: false,
    };
  },
  methods: {
    onClickSubmitButton() {
      if (this.workspaceName === '') {
        this.nameError = true;
      } else {
        this.nameError = false;
      }
      if (this.workspaceDescription === '') {
        this.descriptionError = true;
      } else {
        this.descriptionError = false;
      }

      if (this.nameError || this.descriptionError) {
        return;
      }

      axiosApiInstance
        .post(`/api/v1/workspaces?userId=${this.$store.getters.userId}`, {
          name: this.workspaceName,
          description: this.workspaceDescription,
        })
        .then((response) => {
          if (response.status === 201) {
            this.$emit('updateFolderList', {
              id: response.data.result.workspace_id,
              name: response.data.result.name,
              description: response.data.result.description,
            });
          }
        })
        .finally(() => {
          this.$emit('closeModal');
        });
    },
  },
});
